import {createApp}  from "vue3";
import {get} from "../../../../../assets/js/shared/data-manager";

export default class SocialList {
    constructor($el) {
        this.$el = $el;
        this.$list = this.$el.querySelector('[data-social-list]');

        this.init();
    }

    init() {
        const blockId = this.$el.dataset.blockId;

        const app = createApp({
            el: '[data-socials]',
            data() {
                return {
                    isLoading: false,
                    currentPage: 0,
                    totalCount: null,
                    pager: {},
                    socials: [],
                    scrolledToBottom: false,
                }
            },
            methods: {
                async loadMore() {
                    this.currentPage++;
                    this.isLoading = true;

                    const result = await get(`${placeholders.router.request}/block/${blockId}/ajax/`, {
                        page: this.currentPage,
                    });

                    this.socials = [...this.socials, ...result.publications];
                    this.totalCount = result.totalCount;
                    this.pager = result.pager;
                    this.isLoading = false;
                },
                intro(text) {
                    let div = document.createElement("div");
                    div.innerHTML = text;
                    let out = div.textContent || div.innerText || "";
                    return out.length > 50 ? out.substring(0, 50) + '...' : out;
                },
                openInNewTab(href) {
                    return href.indexOf(location.hostname) == -1 && href.indexOf('http') != -1;
                }
            },
            mounted () {
                console.log('hier');
                this.loadMore();
            }
        });

        app.config.compilerOptions.delimiters = ['v{', '}'];

        // mount the app
        app.mount(this.$el);
    }
}
